import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

export default function initLogoSlider(): void {
  document.querySelectorAll('.logo-slider').forEach((holder) => {
    const swiper = holder.querySelector('.swiper');
    if (swiper) {
      const navNext = holder.querySelector('.swiper-button-next');
      const navPrev = holder.querySelector('.swiper-button-prev');

      // eslint-disable-next-line no-new
      new Swiper(swiper as HTMLElement, {
        modules: [Autoplay, Navigation, Pagination],
        autoplay: holder instanceof HTMLElement && holder.dataset.autoslide === 'true',
        loop: true,
        spaceBetween: 40,
        slidesPerView: 1,
        navigation: {
          nextEl: navNext as HTMLElement | null,
          prevEl: navPrev as HTMLElement | null,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 4,
          },
        },
      });
    }
  });
}
